import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import AsyncSelect from 'react-select/async';

import MainSearchAPI from '../../api/MainSearchAPI';
import Display from '../../util/Display';
import Util from '../../util/Util';
import Const from '../../util/Constants';

class LeadContactPopup extends React.Component {

  constructor(props) {
    super(props);
    this.state = { search: '', selected: null };

    const model = reactLocalStorage.getObject(Const.Model).contact;
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const ContactRestrict = Util.isAllow(model.permission, Const.PermRestricAcc);
   
    this.SearchBody = {};
    const field = 'responsible_person';
    const type = 'multiselect~user';
    const condition = 'in'; 
    const value = `~${[user.user_id, ...user.child].join('~')}~`;
    if(ContactRestrict) { this.SearchBody.contact = [{ field, type, condition, value }]; }
  }

  onSearch = (text, callback) => {
    if (text.length > 2) {
      this.setState({ ...this.state, search: text });
      MainSearchAPI.list(text, this.SearchBody, res => {
        const contacts = res.contacts ? res.contacts.map(contact =>
          { return { value: contact.id, label: Display.ModelName(contact) }; }) : [];
        callback(contacts);
      }, () => callback([]));
    }
    this.setState({ ...this.state, search: text })
  }

  onChange = selected => this.setState({ ...this.state, selected: selected });

  render() {
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Contact</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <AsyncSelect cacheOptions isMulti={false} isClearable={true}
              loadOptions={this.onSearch} onChange={this.onChange} />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          { !this.state.selected &&
            <Button onClick={this.props.redirect}>Add New Contact</Button>
          }
          { this.state.selected &&
            <Button onClick={() => this.props.addContact(this.state.selected)}>
              Add Selected Contact
            </Button>
          }
        </Modal.Footer>
      </Modal>
    );
  }
}
export default LeadContactPopup;